module.exports = __webpack_public_path__ + "img/beer_id-48.0a89a62c.png";